const types = {
  LOGIN: '@auth/LOGIN',
  LOGOUT: '@auth/LOGOUT',
  UPDATE_AUTH: '@auth/UPDATE_AUTH',
  CHECK_AUTH: '@auth/CHECK_AUTH',
  CLEAR_SESSION: '@auth/CLEAR_SESSION',
};

export default types;
